<template>
  <div class="header-wrapper" :class="{ styleChanged: showBar }">
    <div class="main-holder">
      <div class="fake"></div>
      <div class="avatar" @click="openBar()">
        <img :src="user.avatar ? user.avatar : defaultAvatar" alt="" />
        <!-- <input
          type="file"
          @change="changeAvatar"
          ref="avatar"
          :label="$t('authorization.selectImage')"
          accept="image/Jpeg"
        /> -->
        <router-link
          :to="$staffI18nRoute({ name: 'AccountSettings' })"
          class="account-settings"
        >
          <svg
            width="13"
            height="13"
            viewBox="0 0 13 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.6064 7.7795L11.6064 7.77949L11.6044 7.77797L10.7343 7.11876C10.7394 7.04141 10.7428 6.95887 10.7428 6.87321C10.7428 6.78773 10.7396 6.70522 10.7345 6.62757L11.6053 5.96805L11.6068 5.96694C11.9394 5.71226 12.0245 5.2606 11.8203 4.89746L11.8204 4.89741L11.8158 4.88973L10.7524 3.10713C10.5524 2.75755 10.1251 2.59286 9.71587 2.73909L9.71583 2.73896L9.70677 2.74248L8.66789 3.14654C8.5217 3.05285 8.37139 2.96801 8.2175 2.89258L8.06171 1.8402C8.00562 1.41817 7.63381 1.12461 7.22279 1.12461H5.08656C4.67681 1.12461 4.30434 1.41697 4.24856 1.83663L4.09221 2.89392C3.94131 2.96838 3.79236 3.05288 3.64403 3.14771L2.60121 2.74205L2.60122 2.74202L2.59705 2.74046C2.21935 2.59904 1.76371 2.74673 1.56015 3.10321L0.496209 4.88655C0.276004 5.24912 0.371443 5.71302 0.703599 5.968L0.705373 5.96936L1.5756 6.62863C1.56992 6.71351 1.56704 6.79453 1.56704 6.87367C1.56704 6.95294 1.56994 7.03405 1.57563 7.1191L0.704483 7.77884L0.704479 7.77883L0.702622 7.78026C0.37027 8.03547 0.285737 8.48704 0.490132 8.84969L0.490039 8.84974L0.494463 8.85716L1.55801 10.6399C1.75742 10.988 2.18168 11.1546 2.59395 11.0079L2.594 11.0081L2.6035 11.0044L3.64245 10.6003C3.78842 10.6938 3.93857 10.7785 4.09229 10.854L4.24809 11.9061C4.30405 12.3286 4.675 12.6227 5.08702 12.6227H7.22325C7.63256 12.6227 8.00589 12.3308 8.06171 11.9107L8.21808 10.8536C8.36886 10.7791 8.51774 10.6947 8.66631 10.5996L9.70906 11.0053L9.70905 11.0053L9.71259 11.0066C9.80994 11.0433 9.91254 11.0624 10.018 11.0624C10.3169 11.0624 10.6009 10.9057 10.7501 10.6445L11.8182 8.85252L11.8183 8.85257L11.8223 8.84542C12.0264 8.48401 11.9367 8.03343 11.6064 7.7795ZM6.15467 8.32333C5.31298 8.32333 4.64708 7.6625 4.64708 6.87365C4.64708 6.0848 5.31298 5.42398 6.15467 5.42398C6.99636 5.42398 7.66226 6.0848 7.66226 6.87365C7.66226 7.6625 6.99636 8.32333 6.15467 8.32333Z"
              fill="#7197CC"
              stroke="#F8F8F8"
              stroke-width="0.7"
            />
          </svg>
          <svg
            width="13"
            height="13"
            viewBox="0 0 13 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.6064 7.7795L11.6064 7.77949L11.6044 7.77797L10.7343 7.11876C10.7394 7.04141 10.7428 6.95887 10.7428 6.87321C10.7428 6.78773 10.7396 6.70522 10.7345 6.62757L11.6053 5.96805L11.6068 5.96694C11.9394 5.71226 12.0245 5.2606 11.8203 4.89746L11.8204 4.89741L11.8158 4.88973L10.7524 3.10713C10.5524 2.75755 10.1251 2.59286 9.71587 2.73909L9.71583 2.73896L9.70677 2.74248L8.66789 3.14654C8.5217 3.05285 8.37139 2.96801 8.2175 2.89258L8.06171 1.8402C8.00562 1.41817 7.63381 1.12461 7.22279 1.12461H5.08656C4.67681 1.12461 4.30434 1.41697 4.24856 1.83663L4.09221 2.89392C3.94131 2.96838 3.79236 3.05288 3.64403 3.14771L2.60121 2.74205L2.60122 2.74202L2.59705 2.74046C2.21935 2.59904 1.76371 2.74673 1.56015 3.10321L0.496209 4.88655C0.276004 5.24912 0.371443 5.71302 0.703599 5.968L0.705373 5.96936L1.5756 6.62863C1.56992 6.71351 1.56704 6.79453 1.56704 6.87367C1.56704 6.95294 1.56994 7.03405 1.57563 7.1191L0.704483 7.77884L0.704479 7.77883L0.702622 7.78026C0.37027 8.03547 0.285737 8.48704 0.490132 8.84969L0.490039 8.84974L0.494463 8.85716L1.55801 10.6399C1.75742 10.988 2.18168 11.1546 2.59395 11.0079L2.594 11.0081L2.6035 11.0044L3.64245 10.6003C3.78842 10.6938 3.93857 10.7785 4.09229 10.854L4.24809 11.9061C4.30405 12.3286 4.675 12.6227 5.08702 12.6227H7.22325C7.63256 12.6227 8.00589 12.3308 8.06171 11.9107L8.21808 10.8536C8.36886 10.7791 8.51774 10.6947 8.66631 10.5996L9.70906 11.0053L9.70905 11.0053L9.71259 11.0066C9.80994 11.0433 9.91254 11.0624 10.018 11.0624C10.3169 11.0624 10.6009 10.9057 10.7501 10.6445L11.8182 8.85252L11.8183 8.85257L11.8223 8.84542C12.0264 8.48401 11.9367 8.03343 11.6064 7.7795ZM6.15467 8.32333C5.31298 8.32333 4.64708 7.6625 4.64708 6.87365C4.64708 6.0848 5.31298 5.42398 6.15467 5.42398C6.99636 5.42398 7.66226 6.0848 7.66226 6.87365C7.66226 7.6625 6.99636 8.32333 6.15467 8.32333Z"
              fill="#7197CC"
              stroke="#F8F8F8"
              stroke-width="0.7"
            />
          </svg>
        </router-link>
      </div>
      <div class="main-logo">
        <img src="@/assets/zamonuz.png" alt="Zamon" />
        <div class="name" v-if="showBar">
          <h1>{{ user.first_name }} {{ user.last_name }}</h1>
          <h2>{{ user.username }}</h2>
        </div>
      </div>
      <div class="lang-switcher" @click="showLang" v-if="!showBar">
        <div class="lang-holder" ref="language">
          <i class="fas fa-globe globus"></i>
          <span style="text-transform: capitalize">
            {{ $t(`main.short_lang.${i18n.global.locale.value}`) }}</span
          >
          <i class="fas fa-chevron-down down"></i>
          <div class="choices" :class="{ changeHeight: lang }">
            <template v-for="(lang, index) in SUPPORT_LOCALES" :key="index">
              <div
                v-if="lang !== i18n.global.locale.value"
                class="choice-lang"
                @click="switchLanguage(lang)"
              >
                {{ $t(`main.full_lang.${lang}`) }}
              </div>
            </template>
          </div>
        </div>
      </div>
      <div v-if="showBar" class="close-bar">
        <svg
          @click="closeBar"
          width="21"
          height="21"
          viewBox="0 0 21 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21 2.47459L18.5254 0L10.5 8.02538L2.47459 0L0 2.47459L8.02538 10.5L0 18.5254L2.47459 21L10.5 12.9746L18.5254 21L20.9999 18.5254L12.9746 10.5L21 2.47459Z"
            fill="white"
          />
        </svg>
      </div>
    </div>
    <div class="main-holder-spacer" v-if="showBar">
      <div class="elem">
        <div class="stat-elem">
          <div class="add_news">
            <h1>{{ $t("admin.addedNews") }} :</h1>
            <h2>
              {{
                user.published_count +
                user.moderation_count +
                user.declined_count
              }}
            </h2>
          </div>
          <div class="number_views">
            <h1>{{ $t("admin.views") }} :</h1>
            <h2>{{ user.view_count }}</h2>
          </div>
        </div>
        <div class="about">
          <h1>{{ $t("staff_page.about_me") }}</h1>
          <div class="about-description">
            {{ user.bio }}
          </div>
        </div>
        <router-link
          @click="closeBar()"
          :to="$staffI18nRoute({ name: 'PreferredLang' })"
          class="add-article-btn"
        >
          <svg
            width="34"
            height="34"
            viewBox="0 0 34 34"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M34 17C34 26.3967 26.3954 34 17 34C7.60332 34 0 26.3954 0 17C0 16.2665 0.594602 15.6719 1.32812 15.6719C2.06165 15.6719 2.65625 16.2665 2.65625 17C2.65625 24.9284 9.07255 31.3438 17 31.3438C24.9284 31.3438 31.3438 24.9274 31.3438 17C31.3438 9.07162 24.9274 2.65625 17 2.65625C16.2665 2.65625 15.6719 2.06165 15.6719 1.32812C15.6719 0.594602 16.2665 0 17 0C26.3967 0 34 7.60464 34 17ZM10.652 4.10391L12.3698 3.3923C13.0474 3.11153 13.3693 2.33464 13.0885 1.65697C12.8078 0.979293 12.031 0.657289 11.3532 0.938254L9.63535 1.64986C8.95774 1.93063 8.63587 2.70752 8.91663 3.38519C9.19647 4.06061 9.97209 4.38534 10.652 4.10391ZM6.20009 7.51486L7.51486 6.20009C8.03356 5.68139 8.03356 4.84042 7.51486 4.32179C6.99616 3.80315 6.1552 3.80309 5.63656 4.32179L4.32179 5.63656C3.80309 6.15526 3.80309 6.99623 4.32179 7.51486C4.84035 8.03343 5.68139 8.03356 6.20009 7.51486ZM1.65697 13.0886C2.33611 13.3699 3.1122 13.046 3.3923 12.3699L4.10391 10.652C4.38467 9.97429 4.0628 9.1974 3.38519 8.91663C2.70738 8.63593 1.93063 8.95774 1.64986 9.63535L0.938254 11.3532C0.657488 12.031 0.979359 12.8078 1.65697 13.0886ZM17 10.3594C16.2665 10.3594 15.6719 10.954 15.6719 11.6875V15.6719H11.6875C10.954 15.6719 10.3594 16.2665 10.3594 17C10.3594 17.7335 10.954 18.3281 11.6875 18.3281H15.6719V22.3125C15.6719 23.046 16.2665 23.6406 17 23.6406C17.7335 23.6406 18.3281 23.046 18.3281 22.3125V18.3281H22.3125C23.046 18.3281 23.6406 17.7335 23.6406 17C23.6406 16.2665 23.046 15.6719 22.3125 15.6719H18.3281V11.6875C18.3281 10.954 17.7335 10.3594 17 10.3594Z"
              fill="#57CC55"
            />
          </svg>
          {{ $t("admin.add_news") }}
        </router-link>
        <div class="divider"></div>
        <div class="left-collar-actions">
          <div @click.prevent="exitAccount" class="btn">
            <svg
              class="path"
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="25"
              viewBox="0 0 25 25"
              fill="none"
            >
              <path
                d="M17.627 19.3359C17.0876 19.3359 16.6504 19.7731 16.6504 20.3125V23.0469H2.68555V1.95312H16.6504V4.6875C16.6504 5.22686 17.0876 5.66406 17.627 5.66406C18.1663 5.66406 18.6035 5.22686 18.6035 4.6875V0.976562C18.6035 0.437207 18.1663 0 17.627 0H1.70898C1.16963 0 0.732422 0.437207 0.732422 0.976562V24.0234C0.732422 24.5628 1.16963 25 1.70898 25H17.627C18.1663 25 18.6035 24.5628 18.6035 24.0234V20.3125C18.6035 19.7731 18.1663 19.3359 17.627 19.3359Z"
                fill="#949BA4"
              />
              <path
                d="M23.9816 11.8095L21.3576 9.18544C20.9763 8.80405 20.358 8.8041 19.9766 9.18544C19.5952 9.56679 19.5952 10.1852 19.9766 10.5665L20.9335 11.5234L12.8437 11.5234C12.3044 11.5234 11.8672 11.9606 11.8672 12.4999C11.8672 13.0393 12.3044 13.4765 12.8437 13.4765L20.9336 13.4766L19.9766 14.4335C19.5952 14.8148 19.5952 15.4332 19.9766 15.8146C20.358 16.196 20.9763 16.1959 21.3577 15.8145L23.9817 13.1905C23.9817 13.1904 23.9818 13.1903 23.9819 13.1903C24.1784 12.9936 24.2606 12.7664 24.2677 12.5C24.2677 12.2367 24.1559 11.9836 23.9816 11.8095Z"
                fill="#949BA4"
              />
            </svg>
            {{ $t("admin.go_out") }}
          </div>
          <router-link
            @click="closeBar()"
            class="btn"
            :to="$i18nRoute({ name: 'FeedWrapper' })"
          >
            {{ $t("admin.home") }}
          </router-link>
          <router-link
            v-if="user.is_journalist"
            @click="admin()"
            :to="$staffI18nRoute({ name: 'Admin' })"
            class="admin"
          >
            {{ $t("admin.admin") }}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onBeforeUnmount, onMounted, computed } from "vue";
import { useLanguage } from "@/utils/language";
import { useRoute, useRouter } from "vue-router";
import { SUPPORT_LOCALES } from "@/i18n";
import { useStore } from "vuex";
import { updateUser } from "@/network/v1";

export default {
  setup() {
    const store = useStore();
    const isIpad = ref();
    const language = ref(null);
    const showBar = ref(false);
    const lang = ref(false);
    const { i18nRoute } = useLanguage();
    const avatar = ref(null);
    const avatarUrl = ref(null);

    const admin = () => {
      console.log(route);
    };

    const defaultAvatar =
      "https://avatars.mds.yandex.net/get-kino-vod-films-gallery/28788/47e2fd514411e18b76af786d7417062d/600x380";

    const changeAvatar = () => {
      const file = avatar.value.files[0];
      avatarUrl.value = URL.createObjectURL(file);

      const formData = new FormData();

      formData.append("avatar", file);

      updateUser(
        () => {
          console.log("ok");
        },
        store.getters.access,
        formData,
        () => console.log("errr")
      );
    };

    const showLang = () => {
      lang.value = !lang.value;
    };

    const closeLang = (e) => {
      if (language.value) {
        if (!language.value.contains(e.target)) {
          lang.value = false;
        }
      }
    };
    onMounted(() => {
      document.addEventListener("click", closeLang, true);
    });
    onBeforeUnmount(() => {
      if (typeof window !== "undefined") {
        window.removeEventListener("resize", handleResize);
      }
      document.removeEventListener("click", closeLang);
    });

    const Bar = ref(typeof window !== "undefined" && window.innerWidth <= 414);

    const handleResize = () => {
      isIpad.value = window.innerWidth <= 1366;
    };

    const openBar = () => {
      showBar.value = !showBar.value;
    };

    const closeBar = () => {
      showBar.value = false;
      closeBar.value = Bar;
    };
    const route = useRoute();
    const router = useRouter();

    const exitAccount = () => {
      store.commit("flushTokens");
      router.push(i18nRoute({ name: "LogIn_Authorization" }));
    };

    return {
      user: computed(() => store.getters.user),
      Bar,
      openBar,
      isIpad,
      closeBar,
      defaultAvatar,
      route,
      ...useLanguage(),
      SUPPORT_LOCALES,
      showLang,
      language,
      showBar,
      lang,
      closeLang,
      admin,
      exitAccount,
      changeAvatar,
      avatar,
      avatarUrl,
    };
  },
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700;900&display=swap");

.header-wrapper {
  background-color: #143f7b;

  .main-holder {
    width: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    position: relative;
    z-index: 10;

    .avatar {
      display: none;
      cursor: pointer;
    }

    .main-logo {
      width: 21.146vw;
      height: 5.208vw;
      .name {
        display: none;
      }

      img {
        height: 100%;
      }
    }

    .lang-switcher {
      padding: 0.833vw 0;
      align-items: center;
      display: flex;
      height: 100%;
      .lang-holder {
        padding: 0 0.521vw;
        // padding-left: 30px;
        height: 100%;
        cursor: pointer;
        pointer-events: all;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: auto;
        font-size: calc(max(0.729vw, 0.9vw));
        line-height: calc(max(1.458vw, 2vw));
        outline: none;

        .globus {
          margin-right: 0.5vw;
        }
        .down {
          margin-left: 0.191vw;
        }

        .choices {
          position: absolute;
          top: 100%;
          right: 0;
          height: 0;
          overflow: hidden;
          cursor: default;
          background-color: var(--foreground-color);
          border-radius: 0.417vw 0 0.417vw 0.417vw;
          pointer-events: none;
          transition: all 0.4s ease;
          text-shadow: none;
          outline: none;
          margin-top: 0.833vw;
          margin-right: 0.833vw;

          &.changeHeight {
            height: 8.333vw;
          }

          .choice-lang {
            color: var(--secondary-font-color);
            width: 7.292vw;
            height: 2.5vw;
            display: flex;
            align-items: center;
            padding-left: 0.833vw;
            cursor: pointer;
            pointer-events: all;
            transition: all 0.2s;
            outline: none;

            &:hover {
              background-color: var(--background-color);

              outline: none;
              color: var(--primary-font-color);
            }

            &:first-child {
              margin-top: 0.417vw;
              outline: none;
            }

            &:last-child {
              margin-bottom: 0.417vw;
              outline: none;
            }
          }
        }
      }
    }
  }
  .main-holder-spacer {
    position: relative;
  }
}

@media screen and (max-width: 1366px) {
  .header-wrapper {
    max-width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    padding: 0.5rem 0;
    transition: all 0.4s ease;
    .main-holder {
      position: relative;
      display: flex;
      transition: all 0.4s ease;
      .fake {
        display: none;
      }
      .avatar {
        height: 25.911vw;
        width: 9.505vw;
        height: 9.505vw;
        position: relative;
        transition: all 0.4s ease;
        display: block;
        img {
          width: 9.505vw;
          height: 9.505vw;
          border-radius: 50%;
          transition: all 0.4s ease;
        }
        .account-settings {
          display: none;
          position: absolute;
          bottom: -2.5vw;
          left: 50%;
          transform: translateX(-50%);
          width: 5.859vw;
          height: 5.859vw;
          border-radius: 50%;
          background: #f0f0f0;
          transition: background-color 0.4s ease;

          svg {
            position: absolute;
            transition: all 0.4s ease;
            width: 2.604vw;
            height: 2.604vw;

            &:last-child {
              bottom: 1vw;
              left: 1.1vw;
            }

            &:first-child {
              top: 1vw;
              right: 0.7vw;
            }
          }

          &:hover,
          &.router-link-exact-active {
            background: #f8f8f8;
            width: 5.859vw;
            height: 5.859vw;
            border: 2px solid #3b71bc;

            svg {
              &:last-child {
                transform: rotate(60deg);
              }

              &:first-child {
                transform: rotate(-75deg);
              }
            }
          }
        }
      }
      .main-logo {
        width: 33.854vw;
        height: 8.203vw;
        margin-top: 1.172vw;
        position: relative;
        right: 0;
        transition: all 0.4s ease;
        img {
          width: 33.854vw;
          height: 8.203vw;
          margin-top: -1vw;
        }
        .name {
          margin-top: 3.776vw;
          display: block;
          color: white;
          opacity: 0;
          transition: all 0.4s ease;
          h1 {
            font-size: 3.646vw;
            line-height: 4.297vw;
          }
        }
      }

      .lang-switcher {
        margin-top: auto;
        margin-bottom: auto;
        height: 100%;
        .lang-holder {
          padding: 0 0.521vw;
          // padding-left: 30px;
          height: 100%;
          cursor: pointer;
          pointer-events: all;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: auto;
          font-size: calc(max(0.729vw, 0.9vw));
          line-height: calc(max(1.458vw, 2vw));
          outline: none;

          span {
            font-size: 22px;
          }
          i {
            font-size: 20px;
          }

          .choices {
            position: absolute;
            top: 100%;
            right: 0;
            height: 0;
            overflow: hidden;
            cursor: default;
            background-color: var(--foreground-color);
            border-radius: 0.417vw 0 0.417vw 0.417vw;
            pointer-events: none;
            transition: all 0.4s ease;
            text-shadow: none;
            outline: none;
            margin-top: 0.833vw;
            margin-right: 0.833vw;

            &.changeHeight {
              height: 14.333vw;
            }

            .choice-lang {
              color: var(--secondary-font-color);
              width: 13.292vw;
              height: 4.5vw;
              display: flex;
              align-items: center;
              padding-left: 1.833vw;
              cursor: pointer;
              pointer-events: all;
              transition: all 0.2s;
              outline: none;
              font-size: 1.565vw;

              &:hover {
                background-color: var(--background-color);

                outline: none;
                color: var(--primary-font-color);
              }

              &:first-child {
                margin-top: 0.417vw;
                outline: none;
              }

              &:last-child {
                margin-bottom: 0.417vw;
                outline: none;
              }
            }
          }
        }
      }

      .close-bar {
        cursor: pointer;
      }
    }

    .main-holder-spacer {
      position: relative;
      transition: all 0.4s ease;
      padding-top: 5vw;

      .elem {
        position: relative;
        display: grid;
        grid-template-areas:
          "stat about"
          "article-btn about"
          "divider divider"
          "actions actions";
        .stat-elem {
          grid-area: stat;
          display: grid;
          grid-template-columns: auto;
          margin-left: 5vw;
          width: 38.281vw;
          .add_news {
            display: flex;
            justify-content: space-between;
            h1 {
              font-size: 2.344vw;
              line-height: 2.865vw;
              font-weight: 300;
            }
            h2 {
              font-size: 2.604vw;
              line-height: 3.125vw;
              font-weight: 400;
            }
          }
          .number_views {
            display: flex;
            justify-content: space-between;
            h1 {
              font-size: 2.344vw;
              line-height: 2.865vw;
              font-weight: 300;
            }
            h2 {
              font-size: 2.604vw;
              line-height: 3.125vw;
              font-weight: 400;
            }
          }
        }
        .about {
          grid-area: about;
          height: 23.307vw;
          h1 {
            font-size: 2.083vw;
            line-height: 2.474vw;
            font-weight: 500;
            margin-bottom: 1.302vw;
          }
          .about-description {
            width: 45.833vw;
            height: 17vw;
            background: white;
            color: rgba(88, 101, 116, 1);
            padding: 1.953vw;
          }
        }
        .add-article-btn {
          grid-area: article-btn;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 45.703vw;
          height: 7.813vw;
          font-size: 3.885vw;
          line-height: 4.036vw;
          font-weight: 500;
          background: white;
          color: rgba(77, 114, 166, 1);
          margin-top: 3.516vw;
          margin-right: 30px;
          svg {
            width: 4.427vw;
            height: 4.427vw;
            margin-right: 2vw;
          }
        }
        .divider {
          grid-area: divider;
          width: 100%;
          height: 1px;
          background: rgba(108, 143, 186, 1);
          margin-top: 3.255vw;
        }
        .left-collar-actions {
          grid-area: actions;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          .btn,
          .admin {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 19.792vw;
            height: 9.766vw;
            color: rgba(206, 206, 206, 1);
            font-size: 1.885vw;
            line-height: 2.036vw;
            font-weight: 500;
            svg {
              margin-right: 0.651vw;
            }

            &:hover {
              background: rgba(29, 82, 149, 1);
              color: white;
              transition: all 0.4s ease;
            }
          }
        }
      }
    }

    &.styleChanged {
      height: 100%;
      transition: all 0.4s ease;
      .main-holder {
        display: flex;
        align-items: flex-start;
        padding-top: 1.302vw;
        .avatar {
          width: 25.911vw;
          height: 25.911vw;

          img {
            width: 25.911vw;
            height: 25.911vw;
          }
          .account-settings {
            display: block;
          }
        }
        .main-logo {
          right: 7vw;
          transition: all 0.4s ease;
          .name {
            opacity: 1;
            transition: all 0.4s ease;
          }
        }
        .lang-swither {
          display: none;
          transition: all 0.4s ease;
        }
        .close-bar {
          display: block;
          padding-right: 2vw;
          font-size: 2em;
          transition: all 0.4s ease;
          margin-top: 3.646vw;
        }
      }
      .main-holder-spacer {
        display: unset;
        transition: all 0.4s ease;
        height: 100%;
      }
    }
  }
}

@media screen and (max-width: 1025px) {
  .header-wrapper {
    .main-holder {
      .lang-switcher {
        margin-top: auto;
        margin-bottom: auto;
      }
    }
  }
}

@media screen and (max-width: 540px) {
  .header-wrapper {
    .main-holder {
      .avatar {
        .account-settings {
          svg {
            &:last-child {
              bottom: 0.5vw;
              left: 0.9vw;
            }
          }
        }
      }
    }
    .main-holder-spacer {
      padding-top: 16vw;
    }
  }
}

@media screen and (max-width: 414px) {
  .header-wrapper {
    height: 16.267vw;
    .main-holder {
      display: flex;
      align-items: center;
      .avatar {
        display: flex;
        align-items: center;
        width: 13.6vw;
        height: 13.6vw;
        img {
          width: 13.6vw;
          height: 13.6vw;
        }

        .account-settings {
          width: 6.933vw;
          height: 6.933vw;
          position: absolute;
          bottom: -3vw;
          svg {
            width: 2.667vw;
            height: 2.667vw;
            &:last-child {
              bottom: 1.5vw;
              left: 1.5vw;
            }

            &:first-child {
              top: 1.5vw;
              right: 1.2vw;
            }
          }
        }
      }
      .main-logo {
        width: 34.133vw;
        height: 8.267vw;
        .name {
          top: -5.6vw;
          h1 {
            font-size: 5.867vw;
            line-height: 6.933vw;
            width: max-content;
          }
          h2 {
            font-size: 4.267vw;
            line-height: 5.067vw;
            font-weight: 300;
            color: rgba(219, 219, 219, 1);
            margin-top: 1.333vw;
          }
        }
      }
      .lang-switcher {
        margin-top: auto;
        margin-bottom: auto;
        height: 100%;
        .lang-holder {
          padding: 0 0.521vw;
          // padding-left: 30px;
          height: 100%;
          cursor: pointer;
          pointer-events: all;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: auto;
          font-size: calc(max(0.729vw, 0.9vw));
          line-height: calc(max(1.458vw, 2vw));
          outline: none;

          span {
            font-size: 2.865vw;
          }
          i {
            font-size: 2.604vw;
          }

          .choices {
            position: absolute;
            top: 100%;
            right: 0;
            height: 0;
            overflow: hidden;
            cursor: default;
            background-color: var(--foreground-color);
            border-radius: 0.417vw 0 0.417vw 0.417vw;
            pointer-events: none;
            transition: all 0.4s ease;
            text-shadow: none;
            outline: none;
            margin-top: 0.833vw;
            margin-right: 0.833vw;

            &.changeHeight {
              height: 14.333vw;
            }

            .choice-lang {
              color: var(--secondary-font-color);
              width: 13.292vw;
              height: 4.5vw;
              display: flex;
              align-items: center;
              padding-left: 1.833vw;
              cursor: pointer;
              pointer-events: all;
              transition: all 0.2s;
              outline: none;
              font-size: 1.565vw;

              &:hover {
                background-color: var(--background-color);

                outline: none;
                color: var(--primary-font-color);
              }

              &:first-child {
                margin-top: 0.417vw;
                outline: none;
              }

              &:last-child {
                margin-bottom: 0.417vw;
                outline: none;
              }
            }
          }
        }
      }
    }
    .main-holder-spacer {
      display: none;
      .elem {
        display: grid;
        grid-template-areas:
          "stat"
          "about"
          "article-btn"
          "divider"
          "actions";

        .stat-elem {
          width: 89.867vw;
          .add_news {
            h1 {
              font-size: 4.8vw;
              line-height: 5.867vw;
              color: rgba(223, 223, 223, 1);
            }
            h2 {
              font-size: 5.333vw;
              line-height: 6.4vw;
            }
          }
          .number_views {
            h1 {
              font-size: 4.8vw;
              line-height: 5.867vw;
              color: rgba(223, 223, 223, 1);
            }
            h2 {
              font-size: 5.333vw;
              line-height: 6.4vw;
            }
          }
        }

        .about {
          height: 47.733vw;

          margin-top: 5.333vw;
          margin-bottom: 5.333vw;
          margin-left: auto;
          margin-right: auto;

          h1 {
            font-size: 4.267vw;
            line-height: 5.067vw;
            text-align: left;
            margin-bottom: 2.667vw;
          }

          .about-description {
            height: 40vw;
            width: 93.867vw;
          }
        }

        .add-article-btn {
          width: 93.6vw;
          height: 16vw;
          font-size: 6.933vw;
          line-height: 8.267vw;
          margin-bottom: 6.667vw;
          margin-right: 0;

          svg {
            width: 9.067vw;
            height: 9.067vw;
          }
        }

        .left-collar-actions {
          height: 20vw;
          .btn,
          .admin {
            width: 30vw;
            height: 20vw;
          }
        }
      }
    }

    &.styleChanged {
      height: max-content;

      .main-holder {
        align-items: flex-start;
        padding-top: 1.333vw;

        .main-logo {
          right: 4vw;
          margin-top: 2vw;
        }

        .close-bar {
          margin-top: 3vw;
        }
      }

      .main-holder-spacer {
        display: unset;
      }
    }
  }
}

@media screen and (max-width: 360px) {
  .header-wrapper {
    height: 100%;
    .main-holder {
      .lang-switcher {
        padding: 0;
      }
    }
  }
}
</style>
